import { useTranslation } from "react-i18next";

interface BeneficiaryHeaderProps {
  name: string;
  onManageContributions: () => void;
}

const BeneficiaryHeader = ({
  name,
  onManageContributions,
}: BeneficiaryHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="my-12 flex justify-between items-center">
      <p className="text-[24px] font-medium capitalize">{name}</p>
      <button
        data-testid="manage-contributions-button"
        className="bg-white text-[14px] py-2 px-4 rounded-lg hover:bg-opacity-90 transition-all duration-300 border shadow-sm"
        onClick={onManageContributions}
      >
        {t("home.beneficiary_card.manage_contributions")}
      </button>
    </div>
  );
};

export default BeneficiaryHeader;
